import { CUSTOM_PAGE_TYPES } from 'config/constants';
import { FriendlyPagesTypesKey } from 'types/friendlyUrl';
import { StateCreator } from 'zustand';

export type PageType = FriendlyPagesTypesKey | (typeof CUSTOM_PAGE_TYPES)[number];

export type PageLoadingStateSlice = {
    isCartHydrated: boolean;
    isPageLoading: boolean;
    redirectPageType: PageType | undefined;

    updatePageLoadingState: (value: Partial<PageLoadingStateSlice>) => void;
};

export const createPageLoadingStateSlice: StateCreator<PageLoadingStateSlice> = (set) => ({
    isCartHydrated: false,
    isPageLoading: false,
    redirectPageType: undefined,

    updatePageLoadingState: (value) => {
        set((s) => ({ ...s, ...value }));
    },
});
